<template>
    <div>
        <SearchCard @date="onDate"></SearchCard>

        <div class="mt-5 mx-2">
            <button :disabled="!isSearchAllowed"
                    :class="[!isSearchAllowed ? 'bg-gray-400 ' : 'bg-blue-500']"
                    class="w-full py-1 text-white font-bold text-lg"
                    @click="search">
                <SearchSVG></SearchSVG>
                {{ $t('component.search.search') }}
            </button>
        </div>


        <div class="bg-white mt-5 mx-2">
            <div class="flex justify-between px-4 py-4 cursor-pointer"
                 @click="$router.push({ name: 'filter' }).catch(()=>{})">
                <div>
                    {{ $t('component.search.filter' ) }}
                </div>
                <div>
                    <ArrowRightSVG></ArrowRightSVG>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SearchCard from "@/components/cards/SearchCard";
    import SearchSVG from "@/components/shared/svgs/SearchSVG";
    import ArrowRightSVG from "@/components/shared/svgs/ArrowRightSVG";
    import {mapGetters} from "vuex";
    import {EventBus} from "../event-bus";

    export default {
        name: "Search",
        components: {SearchSVG, SearchCard, ArrowRightSVG},
        data() {
            return {
                selectedDate: ''
            }
        },
        computed: {
            ...mapGetters('auth', {
                'loggedIn': 'loggedIn'
            }),
            isSearchAllowed() {
                return !!this.selectedDate;
            }
        },
        mounted() {
            EventBus.$on('onChangeStartDate', async (startDate) => {
                this.selectedDate = startDate;
            });
        },
        methods: {
            onDate(date) {
                this.selectedDate = date;
            },

            async search() {
                await this.$store.dispatch('mission/resetSearch');
                if (this.loggedIn) {
                    this.$store.dispatch('mission/missions').then(() => {
                    });
                    this.$router.push({name: 'missions'}).catch(() => {
                    });
                } else {
                    this.$store.dispatch('mission/anonymizedMissions', {
                        availability_date: this.selectedDate
                    }).then(() => {

                    });
                    this.$router.push({name: 'missions'}).catch(() => {
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>